T.MainTabs = Class(
	/**
	 * @lends {T.MainTabs#}
	 */
	{
		__NAME: 'T.MainTabs',

		_items: {},
		_indexMap: {},

		__construct(par) {
			par = par || {
				items: []
			};
			this.onclick = par.onclick || null;

			this.node = mkE({
				tag: 'div',
				className: 'main-tabs',
				els: [
					this._itemsNode = mkE({
						tag: 'ul'
					})
				]
			});

			if (par.items) {
				this.setItems(par.items);
				if (par.active) {
					this.setActive(par.active);
				}
			}
		},
		setItems(items) {
			for (let i = 0, l = items.length; i < l; i++) {
				let item = items[i];
				let link = mkE({
					tag: 'a',
					href: item.url,
					onclick: D.closure(this, this._onClick, item)
				});
				mkE.appendTypeElement(link, item.caption);
				this._items[item.name] = mkE({
					tag: 'li',
					els: [
						link
					]
				}).append(this._itemsNode);
				this._indexMap[item.name] = i;
			}
		},
		setActive(index) {
			if (index && this._items[index]) {
				addClassName(this._items[index], 'active');
				if (this._indexMap[index] === 0) {
					addClassName(this.node, 'main-tabs-first');
				} else if (this._indexMap[index] === count(this._indexMap) - 1) {
					addClassName(this.node, 'main-tabs-last');
				}
			}
		},
		_onClick(item, e) {
			if (item.onclick) {
				item.onclick(item);
			} else if (this.onclick) {
				return this.onclick(item, e);
			}
		}
	},
	mkE.Base
);
